import { getLogginToken } from '../../utils';
import { createTransport } from './createTransport';

export const createDefaultTransport = () =>
  createTransport({
    Authorization: `Bearer ${getLogginToken()}`,
  });
